import '../styles/app.scss';

/** Autoload */
import './autoload/_vanilla-jq';
import './autoload/_bootstrap';
import './autoload/_fonts';
import './autoload/_form-to-object'; // defines window.formToObject (was an external CDN script)
import './autoload/_shave'; // defines window.shave (was an external CDN script)
import fetchInject from 'fetch-inject';
import { debounce } from 'tiny-throttle';

/* Global vars */
window.debounce = debounce;

/** Util */
import './util/current-breakpoint';
import './util/root';
import './util/body-top-padding';
import './util/scrollbar-width';
import './util/bootstrap-container-width';
import './util/app-height';
import './util/splide-resize-height-of-slider';
import './util/fade-in-up-animation-on-intersection';
import './util/url-updater';
import './util/cards-mutation-observer';
import './util/custom-scroll-to-element';

/** Sections */
import './sections/header';

/** Partials */
import './partials/search-form';

/** Global */
import './global/global';

/** Components */
import './components/splide-slider';
import './components/dropdown';
import './components/datepicker-position';
import './components/custom-checkbox-radio';
import './components/card';
import './components/url-updater';
import './components/open-video-on-modal';
import './components/modal';
import './components/video-play-pause-on-visible';
import './components/card-grid-filters';
import './components/cards-container';
import './components/embedded-video-thumbnail';
import './components/button-group';
import './components/share-buttons';
import './components/invite-link';
import './components/table';
import './components/word-count';

/** Templates */
import './templates/search';

/** Blocks (modules) */
import './blocks/quote';
import './blocks/card-grid-with-filters';
import './blocks/news-critical-band';
import './blocks/events-index';
import './blocks/full-width-cta-card';
import './blocks/member-directory';

/** Make variables globals */
window.fetchInject = fetchInject;
